import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "../styles/LandingPage.scss";
import landingimg from "../images/landing-page-img.jpeg";
import PRP from "../images/PRP.jpeg";
import defaultImage from "../images/default.jpeg";
import about from "../images/about.jpeg";
import { consts } from "../Data/consts";
import lips from "../images/lips.jpeg";
import face_care from "../images/face_care.jpeg";
import nose from "../images/nose.jpeg";
import skincare from "../images/skincare.jpeg";
import botox from "../images/botox.jpg";
import teethStraightening from "../images/teethStraightening.jpeg";
import teethWhitening from "../images/teethWhitening.jpeg";
import {
  useDoctor,
  useFooterData,
  useImagesByTreatmentName,
} from "../Apis/useApiQueries";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import {
  FaChevronLeft,
  FaChevronRight,
  FaWhatsapp,
  FaTimes,
} from "react-icons/fa";
import ContactForm from "../Components/ContactForm";
import { metaPixelEvents } from "../utils/metaPixel";
import { scrollToTop } from "../utils/scrollToTop";

// Custom arrow components for react-slick
const CustomPrevArrow = ({ onClick }) => (
  <div className="slick-prev-custom" onClick={onClick}>
    <i className="fas fa-chevron-right"></i>
  </div>
);

const CustomNextArrow = ({ onClick }) => (
  <div className="slick-next-custom" onClick={onClick}>
    <i className="fas fa-chevron-left"></i>
  </div>
);

const reviews = consts.testimonials;
const images = {
  botox,
  teethStraightening,
  teethWhitening,
  face_care,
  nose,
  skincare,
  PRP,
  lips,
  default: defaultImage,
};

const LandingPage = () => {
  const {
    data: doctor,
    error: doctorError,
    isLoading: doctorLoading,
  } = useDoctor();
  const {
    treatments,
    treatmentsRefs,
    siteDetails,
    error: footerError,
  } = useFooterData();
  // Temporarily disabled to test infinite loop
  // const {
  //   data: dynamicReviews,
  //   isLoading: reviewsLoading,
  //   error: reviewsError,
  // } = useReviews();

  // Fallback data for testing
  const dynamicReviews = [];
  const reviewsLoading = false;
  const reviewsError = null;

  const [animateImg, setAnimateImg] = useState(false);

  // Modal state for image preview
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Touch/swipe functionality for modal
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  // Check if device is mobile
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Track landing page view
  useEffect(() => {
    metaPixelEvents.trackPageView();
  }, []);

  // Fetch images for all treatments using individual hooks (must be at top level)
  const botoxImages = useImagesByTreatmentName("טיפולי בוטוקס");
  const hairImages = useImagesByTreatmentName("טיפולי שיער");
  const lipsImages = useImagesByTreatmentName("פיסול שפתיים");
  const noseImages = useImagesByTreatmentName("פיסול אף");
  const faceImages = useImagesByTreatmentName("פיסול פנים");
  const teethWhiteningImages = useImagesByTreatmentName("הלבנת שיניים");
  const teethStraighteningImages = useImagesByTreatmentName("יישור שיניים");

  // Create carousel items from all treatment images
  const [carouselItems, setCarouselItems] = useState([]);

  useEffect(() => {
    const treatmentImageData = [
      { name: "הלבנת שיניים", images: teethWhiteningImages.data || [] },
      { name: "פיסול פנים", images: faceImages.data || [] },
      { name: "פיסול אף", images: noseImages.data || [] },
      { name: "פיסול שפתיים", images: lipsImages.data || [] },
      { name: "טיפולי שיער", images: hairImages.data || [] },
      { name: "טיפולי בוטוקס", images: botoxImages.data || [] },
      { name: "יישור שיניים", images: teethStraighteningImages.data || [] },
    ];

    const items = [];
    treatmentImageData.forEach(({ name, images }) => {
      if (images.length > 0) {
        // Add only the FIRST image from each treatment
        items.push({
          treatmentName: name,
          image: images[0], // Only take the first image
          totalImages: images.length,
        });
      }
    });
    setCarouselItems(items);
  }, [
    botoxImages.data,
    hairImages.data,
    lipsImages.data,
    noseImages.data,
    faceImages.data,
    teethWhiteningImages.data,
    teethStraighteningImages.data,
  ]);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    rtl: true, // Right-to-left auto-scroll direction
    arrows: false, // Disable navigation arrows
    swipe: true, // Enable swipe on desktop
    touchMove: true, // Enable touch movement
    swipeToSlide: true, // Allow swiping to any slide
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  // Before and After carousel settings
  const beforeAfterSettings = {
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    rtl: true, // Right-to-left auto-scroll direction
    dots: true,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  };

  // Modal handlers for image preview
  const openImageModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
    document.body.classList.add("prevent-scroll");
    metaPixelEvents.trackViewContent(
      "image_preview",
      carouselItems[index]?.treatmentName
    );
  };

  const closeImageModal = () => {
    setIsModalOpen(false);
    document.body.classList.remove("prevent-scroll");
  };

  const goToNextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % carouselItems.length);
  };

  const goToPrevImage = () => {
    setCurrentImageIndex((prev) =>
      prev === 0 ? carouselItems.length - 1 : prev - 1
    );
  };

  // Touch event handlers for swipe functionality
  const handleTouchStart = (e) => {
    setTouchEnd(0); // Reset touchEnd
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
    // Note: We can't preventDefault here due to passive listeners
    // Instead, we use CSS touch-action: pan-x to handle this
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 30; // Reduced sensitivity for easier swiping
    const isRightSwipe = distance < -30;

    if (isLeftSwipe && carouselItems.length > 1) {
      goToNextImage();
    }
    if (isRightSwipe && carouselItems.length > 1) {
      goToPrevImage();
    }

    // Reset touch values
    setTouchStart(0);
    setTouchEnd(0);
  };

  // Keyboard navigation for modal
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (!isModalOpen) return;

      switch (e.key) {
        case "Escape":
          closeImageModal();
          break;
        case "ArrowLeft":
          goToPrevImage();
          break;
        case "ArrowRight":
          goToNextImage();
          break;
        default:
          break;
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    return () => document.removeEventListener("keydown", handleKeyPress);
  }, [isModalOpen, carouselItems.length]);

  React.useEffect(() => {
    const timer = setTimeout(() => setAnimateImg(true), 100);
    return () => clearTimeout(timer);
  }, []);

  if (footerError || doctorError) {
    return (
      <p className="error">
        Error: {footerError?.message || doctorError?.message}
      </p>
    );
  }

  return (
    <div className="landing-page">
      <main>
        {/* Modern Hero Section */}
        {doctor || (!doctorLoading && !doctor) ? (
          <div className="doctor-info">
            {/* Animated Background Elements */}
            <div className="hero-bg-elements">
              <div className="bg-shape bg-shape-1"></div>
              <div className="bg-shape bg-shape-2"></div>
              <div className="bg-shape bg-shape-3"></div>
              <div className="bg-particles">
                <div className="particle particle-1"></div>
                <div className="particle particle-2"></div>
                <div className="particle particle-3"></div>
                <div className="particle particle-4"></div>
                <div className="particle particle-5"></div>
              </div>
            </div>

            <div className="hero-content">
              <div className="hero-visual">
                <div className="visual-container">
                  {/* Central doctor image/icon */}
                  <div className="central-image">
                    <div className="doctor-avatar"></div>
                  </div>

                  {/* Orbiting treatment icons */}
                  <div className="orbiting-treatments">
                    <div className="orbit-treatment orbit-treatment-1">
                      <span>בוטוקס</span>
                    </div>
                    <div className="orbit-treatment orbit-treatment-2">
                      <span>פיסול שפתיים</span>
                    </div>
                    <div className="orbit-treatment orbit-treatment-3">
                      <span>הלבנת שיניים</span>
                    </div>
                    <div className="orbit-treatment orbit-treatment-4">
                      <span>פיסול פנים</span>
                    </div>
                    <div className="orbit-treatment orbit-treatment-5">
                      <span>פיסול אף</span>
                    </div>
                    <div className="orbit-treatment orbit-treatment-6">
                      <span>טיפולי שיער</span>
                    </div>
                    <div className="orbit-treatment orbit-treatment-7">
                      <span>יישור שיניים</span>
                    </div>
                  </div>

                  {/* Pulse rings */}
                  <div className="pulse-rings">
                    <div className="pulse-ring ring-1"></div>
                    <div className="pulse-ring ring-2"></div>
                    <div className="pulse-ring ring-3"></div>
                  </div>
                </div>
              </div>

              <div className="hero-text">
                <div className="hero-badge">
                  <span>רופא מומחה</span>
                </div>
                <h1>
                  <span className="highlight">ד״ר שי תלם</span>
                  <span className="subtitle">רפואה אסתטית מתקדמת ומקצועית</span>
                </h1>
                <p className="hero-description" dir="rtl">
                  מתמחה בטיפולים אסתטיים מתקדמים עם גישה אישית ומקצועית. מעניק
                  פתרונות מותאמים אישית למטופלים בשתי מרפאות מתקדמות עם
                  הטכנולוגיות החדישות ביותר.
                </p>
                <div className="hero-actions">
                  <a
                    href="https://wa.me/+972532268138?text=שלום, אני מעוניין/ת לקבוע תור לטיפול אסתטי"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hero-cta primary"
                    onClick={() =>
                      metaPixelEvents.trackInitiateCheckout("hero_whatsapp")
                    }
                  >
                    <FaWhatsapp />
                    <span>קבעו תור עכשיו</span>
                  </a>
                  <Link
                    to="/about"
                    className="hero-cta secondary"
                    onClick={() => {
                      metaPixelEvents.trackAboutView();
                      scrollToTop();
                    }}
                  >
                    <span>למידע נוסף</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ) : doctorLoading ? (
          <div className="hero-loading">
            <div className="loading-spinner"></div>
            <p>טוען מידע...</p>
          </div>
        ) : null}

        {/* Our Treatments Section */}
        <div className="treatments-section" id="treatments-section">
          <div className="treatments-container">
            <div className="treatments-header">
              <h2>הטיפולים שלנו</h2>
              <p>גלו את מגוון הטיפולים המתקדמים שאנו מציעים</p>
              <div className="header-divider"></div>
            </div>

            <div
              className="treatments-grid"
              data-item-count={
                (treatmentsRefs.data?.length || 0) +
                (treatments.data?.filter(
                  (treatment) =>
                    !treatmentsRefs.data?.some(
                      (refTreatment) =>
                        refTreatment.treatmentRef === treatment.treatmentRef
                    )
                )?.length || 0)
              }
            >
              {treatmentsRefs.data?.length > 0 ||
              (!treatmentsRefs.isLoading &&
                treatmentsRefs.data?.length === 0) ? (
                treatmentsRefs.data.map((treatment, index) => (
                  <div
                    key={treatment._id}
                    className="modern-treatment-card"
                    style={{ "--delay": `${index * 0.1}s` }}
                  >
                    <Link
                      to={
                        treatment.treatmentRef
                          ? `/treatments/${treatment.treatmentRef}`
                          : `/treatment/${treatment.name}`
                      }
                      className="treatment-card-link"
                      onClick={() => {
                        metaPixelEvents.trackSearch(
                          treatment.treatmentRef || treatment.name
                        );
                        scrollToTop();
                      }}
                    >
                      <div className="treatment-image-container">
                        <img
                          src={
                            treatment.imgName
                              ? images[treatment.imgName]
                              : images.default
                          }
                          className="treatment-image"
                          alt={treatment.treatmentRef || treatment.name}
                        />
                        <div className="treatment-overlay">
                          <div className="treatment-icon">
                            <i className="fa-solid fa-arrow-left"></i>
                          </div>
                        </div>
                      </div>
                      <div className="treatment-content">
                        <h3 dir="auto">{treatment.treatmentRef}</h3>
                        <div className="treatment-arrow">
                          <i className="fa-solid fa-chevron-left"></i>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))
              ) : treatmentsRefs.isLoading ? (
                <div className="treatments-loading">
                  <p dir="auto">טוען טיפולים...</p>
                </div>
              ) : null}

              {treatments.data?.length > 0 ? (
                treatments.data
                  .filter(
                    (treatment) =>
                      !treatmentsRefs.data?.some(
                        (refTreatment) =>
                          refTreatment.treatmentRef === treatment.treatmentRef
                      )
                  )
                  .map((treatment, index) => (
                    <div
                      key={treatment._id}
                      className="modern-treatment-card"
                      style={{
                        "--delay": `${
                          (index + (treatmentsRefs.data?.length || 0)) * 0.1
                        }s`,
                      }}
                    >
                      <Link
                        to={`/treatment/${treatment.name}`}
                        className="treatment-card-link"
                        onClick={() => {
                          metaPixelEvents.trackViewContent(
                            treatment.name,
                            treatment.treatmentRef
                          );
                          scrollToTop();
                        }}
                      >
                        <div className="treatment-image-container">
                          <img
                            src={
                              treatment.imgName
                                ? images[treatment.imgName]
                                : images.default
                            }
                            className="treatment-image"
                            alt={treatment.name}
                          />
                          <div className="treatment-overlay">
                            <div className="treatment-icon">
                              <i className="fa-solid fa-arrow-left"></i>
                            </div>
                          </div>
                        </div>
                        <div className="treatment-content">
                          <h3>{treatment.name}</h3>
                          <div className="treatment-arrow">
                            <i className="fa-solid fa-chevron-left"></i>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))
              ) : treatments.isLoading ? (
                <div className="treatments-loading">
                  <p>טוען טיפולים...</p>
                </div>
              ) : null}
            </div>
          </div>
        </div>

        {/* Before and After Carousel Section */}
        <div className="before-after-carousel-section">
          <div className="before-after-carousel-container">
            <div className="before-after-header">
              <h2>גלריית לפני ואחרי</h2>
              <p>צפו בתוצאות המדהימות של כל הטיפולים שלנו</p>
              <div className="header-divider"></div>
            </div>

            {carouselItems.length > 0 ? (
              <div className="before-after-carousel">
                <Slider {...beforeAfterSettings}>
                  {carouselItems.map((item, index) => (
                    <div
                      key={`${item.treatmentName}-${index}`}
                      className="carousel-slide"
                    >
                      <div className="carousel-item">
                        <div
                          className="carousel-image-container"
                          onClick={() => openImageModal(index)}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={item.image}
                            alt={`${item.treatmentName} - לפני ואחרי`}
                            loading="lazy"
                          />
                          <div className="carousel-overlay">
                            <div className="overlay-content">
                              <span className="overlay-text">לחץ לצפייה</span>
                              <div className="overlay-icon">
                                <i className="fas fa-expand"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="carousel-content">
                          <h3>{item.treatmentName}</h3>
                          <Link
                            to={`/before-and-after/${encodeURIComponent(
                              item.treatmentName
                            )}`}
                            className="carousel-view-btn"
                            onClick={() => {
                              metaPixelEvents.trackViewContentImages(
                                item.treatmentName
                              );
                              scrollToTop();
                            }}
                          >
                            צפו בגלריה
                            <i className="fas fa-arrow-left"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            ) : (
              <div className="carousel-loading">
                <div className="loading-spinner"></div>
                <p>טוען גלריית תמונות...</p>
              </div>
            )}

            <div className="before-after-cta">
              <h3>מעוניינים בייעוץ אישי?</h3>
              <p>צרו איתנו קשר לקבלת מידע מפורט על הטיפולים</p>
            </div>
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="landing-contact-section">
          <div className="contact-header">
            <h2>צרו איתנו קשר</h2>
            <p>נשמח לענות על כל שאלה ולתת לכם מענה מהיר</p>
            <div className="header-divider"></div>
          </div>
          <ContactForm />
        </div>

        {/* Customer Reviews */}
        <div className="reviews-section">
          <div className="reviews-title">
            <h2>לקוחות ממליצים</h2>
            <a
              href="https://easy.co.il/page/10144307"
              target="_blank"
              rel="noreferrer"
            >
              <FaArrowUpRightFromSquare className="review-icon" />
              לכל חוות הדעת
            </a>
          </div>
          {reviewsLoading ? (
            <div className="reviews-loading">
              <p>טוען ביקורות...</p>
            </div>
          ) : (
            <Slider {...settings}>
              {(dynamicReviews && dynamicReviews.length > 0
                ? dynamicReviews
                : reviews
              ).map((review) => (
                <div key={review.id} className="review-card">
                  <p>{review.text}</p>
                  <h3>- {review.name}</h3>
                  {dynamicReviews && dynamicReviews.length > 0 && (
                    <span className="review-source">
                      מתעדכן אוטומטית מ-Easy.co.il
                    </span>
                  )}
                </div>
              ))}
            </Slider>
          )}
        </div>

        {/* About the Doctor Section */}
        <div className="doctor-about-section">
          <div className="about-container">
            <div className="about-header">
              <h2>היכרות עם הרופא</h2>
              <div className="header-divider"></div>
            </div>

            <div className="about-content-landing-page">
              <div className="doctor-image-container">
                <div className="doctor-image-wrapper">
                  <img className="doctor-image" src={about} alt="ד״ר שי תלם" />
                  <div className="image-overlay"></div>
                </div>
                <div className="credentials-badge">
                  <span>רופא מוסמך</span>
                </div>
              </div>

              <div className="doctor-info-content">
                <div className="doctor-title-section">
                  <h1 className="doctor-name">{consts.dr_name}</h1>
                  <h3 className="doctor-specialty">{consts.dr_title}</h3>
                </div>

                <div className="doctor-description">
                  <p>{consts.dr_description}</p>
                </div>

                <div className="specialties-grid"></div>

                <div className="doctor-stats">
                  <div className="stat-item">
                    <div className="stat-number">טבעי</div>
                    <div className="stat-label">תוצאות טבעיות</div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-number">
                      <div className="stars-row">★★★</div>
                      <div className="stars-row">★★</div>
                    </div>
                    <div className="stat-label">דירוג מטופלים</div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-number">100%</div>
                    <div className="stat-label">מחויבות לאיכות</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Image Preview Modal */}
      {isModalOpen && carouselItems.length > 0 && (
        <div className="image-modal-overlay" onClick={closeImageModal}>
          <div className="image-modal-container">
            <div className="image-modal-header">
              <div className="modal-title">
                <span>{carouselItems[currentImageIndex]?.treatmentName}</span>
                <span className="image-counter">
                  {currentImageIndex + 1} מתוך {carouselItems.length}
                </span>
                {carouselItems.length > 1 && isMobile && (
                  <span className="swipe-hint">החליקו ימינה ושמאלה לעיון</span>
                )}
              </div>
              <button className="modal-close-button" onClick={closeImageModal}>
                <FaTimes />
              </button>
            </div>

            <div
              className="image-modal-content"
              onClick={(e) => e.stopPropagation()}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              <img
                key={currentImageIndex}
                src={carouselItems[currentImageIndex]?.image}
                alt={`לפני ואחרי - ${carouselItems[currentImageIndex]?.treatmentName}`}
                className="modal-image"
              />

              {carouselItems.length > 1 && !isMobile && (
                <div className="modal-navigation-arrows">
                  <button
                    className="modal-arrow modal-prev-arrow"
                    onClick={goToPrevImage}
                    title="תמונה קודמת"
                  >
                    <FaChevronRight />
                  </button>
                  <button
                    className="modal-arrow modal-next-arrow"
                    onClick={goToNextImage}
                    title="תמונה הבאה"
                  >
                    <FaChevronLeft />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPage;
